import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import logoLight from '../../assets/imgs/Logo_principal.webp';
import { CONTACT, buildWhatsAppUrl } from '../../data/site';
import { COMPLAINTS_PROVIDER } from '../../data/reclamaciones';
import { MEDICAL_NEGLIGENCE_WHATSAPP_MESSAGE } from '../../data/medicalNegligenceLanding';
import { Icon } from '../Icon';
import { ScrollToTop } from '../ScrollToTop';

type Props = {
  children: ReactNode;
};

export function CampaignLandingLayout({ children }: Props) {
  const whatsappUrl = buildWhatsAppUrl(MEDICAL_NEGLIGENCE_WHATSAPP_MESSAGE);

  return (
    <div className="campaign-landing-shell">
      <ScrollToTop />

      <header className="campaign-header">
        <div className="site-container campaign-header__inner">
          <Link
            className="campaign-header__brand"
            to="/"
            data-analytics-event="institutional_site_click"
            aria-label="Corporación Indemniza, ir al sitio institucional"
          >
            <img src={logoLight} alt="Corporación Indemniza" />
            <span>Especialistas en reparaciones y compensaciones</span>
          </Link>

          <div className="campaign-header__actions">
            <a
              className="campaign-header__phone"
              href={`tel:+${CONTACT.phoneInternational}`}
              data-analytics-event="header_phone"
              aria-label={`Llamar a Corporación Indemniza al ${CONTACT.phoneDisplay}`}
            >
              <Icon name="phone" size={18} />
              <span>{CONTACT.phoneDisplay}</span>
            </a>
            <a
              className="campaign-button campaign-button--gold campaign-header__whatsapp"
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-analytics-event="header_whatsapp"
            >
              <Icon name="whatsapp" size={18} />
              <span>Cuéntanos tu caso</span>
            </a>
          </div>
        </div>
      </header>

      <main>{children}</main>

      <footer className="campaign-footer">
        <div className="site-container campaign-footer__grid">
          <div>
            <strong>Corporación Indemniza</strong>
            <p>{COMPLAINTS_PROVIDER.razonSocial}</p>
            <p>RUC {COMPLAINTS_PROVIDER.ruc}</p>
          </div>
          <address>
            <span>{CONTACT.address}</span>
            <a href={`tel:+${CONTACT.phoneInternational}`}>{CONTACT.phoneDisplay}</a>
            <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            <a href={CONTACT.website} target="_blank" rel="noopener noreferrer" data-analytics-event="institutional_site_click">www.indemniza.pe</a>
          </address>
        </div>
        <div className="site-container campaign-footer__legal">
          <p>© {new Date().getFullYear()} Corporación Indemniza. Todos los derechos reservados.</p>
          <nav aria-label="Enlaces legales">
            <a href="/politica-de-privacidad" target="_blank" rel="noopener noreferrer">Política de privacidad</a>
            <a href="/terminos" target="_blank" rel="noopener noreferrer">Términos y condiciones</a>
            <Link to="/libro-de-reclamaciones" target="_blank" rel="noopener noreferrer">Libro de Reclamaciones</Link>
          </nav>
        </div>
      </footer>

      <nav className="campaign-mobile-actions" aria-label="Acciones de contacto rápidas">
        <a href={`tel:+${CONTACT.phoneInternational}`} data-analytics-event="mobile_phone">
          <Icon name="phone" size={19} />
          <span>Llamar</span>
        </a>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-analytics-event="mobile_whatsapp"
        >
          <Icon name="whatsapp" size={19} />
          <span>Cuéntanos tu caso</span>
        </a>
      </nav>
    </div>
  );
}
